// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"26308586","121":"4e30dd0f","257":"22f45b0a","592":"b7f5347f","725":"9ed0dc6c"}[chunkId] + ".chunk.css";
};